import React, { useState } from "react";
import Button from "components/Elements/Button/Button.js";
import Image from "components/Elements/Image/Image.tsx";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import Login from "components/Structure/Login/Login.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import parse from "html-react-parser";
import useMediaQueries from "hooks/useMediaQueries.js";

const AdblockerModal = () => {
  const { newMobileCondition } = useMediaQueries();
  const { isLoggedIn } = useUser();
  const [isStep1, setIsStep1] = useState(true);
  const { getTextByKey } = useContent();
  const { closeModal, setModal } = useModal();
  const uBlockInstructions = [
    "u-block-ins-1",
    "u-block-ins-2",
    "u-block-ins-3",
  ];
  const adBlockInstructions = [
    "ad-block-ins-1",
    "ad-block-ins-2",
    "ad-block-ins-3",
  ];
  const adBlockPlusInstructions = [
    "ad-block-plus-ins-1",
    "ad-block-plus-ins-2",
    "ad-block-plus-ins-3",
  ];
  const blocksElements = {
    uBlock: {
      className: "uBlock",
      name: "uBlock",
      image: "icon_ublock",
      insgif: "uBlock_screens",
      listIns: uBlockInstructions,
    },
    AdBlock: {
      className: "AdBlock",
      name: "AdBlock",
      image: "icon_adblock",
      insgif: "AdBlock_screens",
      listIns: adBlockInstructions,
    },
    adblockplus: {
      className: "adblockplus",
      name: "AdBlock Plus",
      image: "icon_adblock_plus",
      insgif: "ABP_screens",
      listIns: adBlockPlusInstructions,
    },
  };

  const [activeBlockItem, setActiveBlockItem] = useState(blocksElements.uBlock);
  const loginModal = async () => {
    setModal({
      modal: Login,
      modalSize: "full-modal",
    });
  };
  const step1 = () => {
    return (
      <div className="ad-blocker-container step-1-ad-block">
        <div className="ad-blocker-image">
          <Image name="ad-block-modal/ad-blocker-modal-image" ext="svg" />
        </div>
        <div className="ad-blocker-title">
          <h2>{getTextByKey("ad-blocker-activate-title")}</h2>
        </div>
        <div className="ad-blocker-text">
          {parse(getTextByKey("ad-blocker-activate-text"))}
        </div>
        <div className="ad-blocker-actions">
          <Button
            blank
            className="new-button"
            onClick={() => setIsStep1(false)}
          >
            {getTextByKey("ad-blocker-turn-off")}
          </Button>
          <LinkToNewTab isNewTab page="plans">
            <Button className="new-button">
              {getTextByKey("ad-blocker-go-pro")}
            </Button>
          </LinkToNewTab>
        </div>
        {!isLoggedIn() && (
          <div className="ad-blocker-sign-in">
            <p>
              {getTextByKey("already-subscriber")}{" "}
              <span className="sign-in" onClick={() => loginModal()}>
                {getTextByKey("sign-in")}
              </span>
            </p>
          </div>
        )}
      </div>
    );
  };
  const renderBlockInstructions = () => {
    let blockIns = activeBlockItem ? activeBlockItem.listIns : [];
    return (
      <div className="instructions-ul">
        <ol>
          {blockIns.map((item, index) => (
            <li key={index}>{getTextByKey(item)}</li>
          ))}
        </ol>
      </div>
    );
  };

  const closeAndRefresh = () => {
    closeModal();
    window.location.reload();
  };
  const step2 = () => {
    return (
      <div className="ad-blocker-container step-2-ad-block">
        <div className="ad-blocker-title">
          <h2>{getTextByKey("select-ad-blocker")}</h2>
        </div>
        <div className="list-blocks">
          {blocksElements &&
            Object.keys(blocksElements).map((block, index) => (
              <div
                className="block-item"
                onClick={() => setActiveBlockItem(blocksElements[block])}
                key={index}
              >
                <div className="block-image">
                  <Image
                    name={`ad-block-modal/${blocksElements[block].image}`}
                    ext="png"
                  />
                </div>
                <h3>{blocksElements[block].name}</h3>
              </div>
            ))}
          <div
            className={`slider ${activeBlockItem && activeBlockItem.className}`}
          ></div>
        </div>
        <div className="adblock-instructions">
          <div className="instructions-side">
            {renderBlockInstructions()}
            {newMobileCondition && (
              <div className="image-side">
                <Image
                  name={`ad-block-modal/${
                    activeBlockItem && activeBlockItem.insgif
                  }`}
                  ext="gif"
                  alt=""
                  title=""
                />
              </div>
            )}
            <div className="ad-blocker-actions">
              <Button
                blank
                className="new-button"
                onClick={() => closeAndRefresh()}
              >
                {getTextByKey("ad-blocker-close-button")}
              </Button>
            </div>
          </div>
          {!newMobileCondition && (
            <div className="image-side">
              <Image
                name={`ad-block-modal/${
                  activeBlockItem && activeBlockItem.insgif
                }`}
                ext="gif"
                alt=""
                title=""
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  return <div className="ad-blocker-modal">{isStep1 ? step1() : step2()}</div>;
};

export default AdblockerModal;
